import VideocamIcon from '@mui/icons-material/Videocam';

import { redirectToG500LiteMoveInfoPage } from '../../common/utils/redirectToG500Lite';
import { redirectToOffsegEventVideoListPage } from '../../common/utils/redirectToOffseg';
import { MenuItemListType } from '../../common/type/MenuItemListType';

export const pageName = 'イベント映像一覧';

export const tableColumnList = [
	{ id: 'occurrenceDatetime', label: 'イベント発生日時', minWidth: 150 },
	{ id: 'organizationName', label: '組織(車両)', minWidth: 150 },
	{ id: 'carCode', label: '車両番号', minWidth: 70 },
	{ id: 'numberPlate', label: 'ナンバープレート', minWidth: 150 },
	{ id: 'driverName', label: 'ドライバー名', minWidth: 150 },
	{ id: 'model', label: 'モデル', minWidth: 60 },
	{ id: 'eventType', label: 'イベント種類', minWidth: 90 },
	{ id: 'gValue', label: 'G値', minWidth: 60 },
	{ id: 'hiyariLevel', label: 'ヒヤリ度', minWidth: 60 },
	{ id: 'legalSpeed', label: '法定速度 (km/h)', minWidth: 130 },
	{ id: 'overspeed', label: '超過速度 (km/h)', minWidth: 130 },
	{ id: 'hiyariResult', label: 'ヒヤリ判定', minWidth: 85 },
];

export const offsegMenuItemList: MenuItemListType = [
	{
		value: 'イベント映像一覧',
		name: 'イベント映像一覧',
		onClick: redirectToOffsegEventVideoListPage,
		icon: VideocamIcon,
	},
];

export const g500LiteMenuItemList: MenuItemListType = [
	{
		value: '映像をみる',
		name: '映像をみる',
		onClick: redirectToG500LiteMoveInfoPage,
		icon: VideocamIcon,
	},
];

export const resultNumLable = {
	title: 'イベント映像件数',
	offseg: 'Offseg：',
	g500Lite: 'G500Lite：',
	sum: '合計：',
	unit: '件',
};
